import { numberThousand, numberMoney } from 'Data/format.js'
import { DOWNPAYMENT_TYPE } from 'Data/payment-plan.js'

export function getValue(ortho_coverages) {
  return ortho_coverages.downpayment_type === DOWNPAYMENT_TYPE.PERCENTAGE
    ? `${numberThousand(ortho_coverages.downpayment_percentage * 100)}%`
    : numberMoney(ortho_coverages.downpayment_amount)
}
